export const UNLOCK_LOCK_REQUEST = 'UNLOCK_LOCK_REQUEST';
export const UNLOCK_LOCK_SUCCESS = 'UNLOCK_LOCK_SUCCESS';
export const UNLOCK_LOCK_FAILURE = 'UNLOCK_LOCK_FAILURE';

export const DISCARD_LOCK_REQUEST = 'DISCARD_LOCK_REQUEST';
export const DISCARD_LOCK_SUCCESS = 'DISCARD_LOCK_SUCCESS';
export const DISCARD_LOCK_FAILURE = 'DISCARD_LOCK_FAILURE';

export const CURRENT_STATUS_REQUEST = 'CURRENT_STATUS_REQUEST';
export const CURRENT_STATUS_SUCCESS = 'CURRENT_STATUS_SUCCESS';
export const CURRENT_STATUS_FAILURE = 'CURRENT_STATUS_FAILURE';

export const START_PUBLISH_STEP_POLL = 'START_PUBLISH_STEP_POLL';
export const STOP_PUBLISH_STEP_POLL = 'STOP_PUBLISH_STEP_POLL';

export const RESET_OPERATION_INFO = 'RESET_OPERATION_INFO';

export const MULTI_STATUS_REQUEST = 'MULTI_STATUS_REQUEST';
export const MULTI_STATUS_SOCKET_REQUEST = 'MULTI_STATUS_SOCKET_REQUEST';
export const MULTI_STATUS_SUCCESS = 'MULTI_STATUS_SUCCESS';
export const MULTI_STATUS_FAILURE = 'MULTI_STATUS_FAILURE';

export const START_MULTI_STATUS_POLL = 'START_MULTI_STATUS_POLL';
export const STOP_MULTI_STATUS_POLL = 'STOP_MULTI_STATUS_POLL';

export const SET_IDS_TO_POLL = 'SET_IDS_TO_POLL';

export const ABORT_REQUEST = 'ABORT_REQUEST';
export const ABORT_SUCCESS = 'ABORT_SUCCESS';
export const ABORT_FAILURE = 'ABORT_FAILURE';

export const RESET_ABORT = 'RESET_ABORT';

export const RESET_MULTI_POLLING = 'RESET_MULTI_POLLING';
